<template>
  <div>
    <!-- Fixed -->
    <div id="fixed-header" class="ui container fixed-header">
      <div class="left">
        <a href="https://bioveikals.com">
          <img src="./../assets/bv_logo_small.png" class="logo"></img>
        </a>
      </div>
      <div class="right">
        <div class="ui icon input">
          <input id="fixed-search-field" type="text" placeholder="Meklēt..." :class="{ disabled: storeStatus.loading }" @keyup.enter="setSearchTerm($event.target.value)" :value="searchTerm">
          <i class="search link icon" :class="{ disabled: storeStatus.loading }" v-on:click.prevent="setSearchTerm($event.target.offsetParent.firstChild.value)" :value="searchTerm"></i>
        </div>
      </div>
    </div>
    <!-- /Fixed -->
    <div v-if="!checkClientWidth" class="ui stackable secondary menu equal width grid compact">
      <span><a class="link item" :class="{ disabled: storeStatus.loading }" @click.prevent="filterCategory('','','','','','')">Visi produkti</a></span>
      <span v-for="item in category">
        <div v-if="item.category_a.length > 0" class="ui pointing dropdown link item categorymenu">
          <span class="text" :class="{ disabled: storeStatus.loading }">{{item.category}}</span>
          <i class="dropdown icon" :class="{ disabled: storeStatus.loading }"></i>
          <div class="menu">
            <!--<div class="header">Categories</div> -->
            <div v-for="categorya in item.category_a" class="item" style="padding: 0 !important;">
              <div style="padding: 11px 16px;" @click.prevent="filterCategory('',categorya.id,'',item.link,categorya.link,'')"><i v-if="categorya.category_b.length>0"
                  class="dropdown icon"></i>
                <span class="text">{{categorya.category}}</span></div>
              <div class="menu" v-if="categorya.category_b.length>0">
                <div class="item" v-for="categoryb in categorya.category_b" @click.prevent="filterCategory('','',categoryb.id,item.link,categorya.link,categoryb.link)">
                  <span>{{categoryb.category}}</span></div>
              </div>
            </div>
          </div>
        </div>
        <a v-else class="item" :class="{ disabled: storeStatus.loading }" @click.prevent="filterCategory(item.id,'','',item.link,'','')">{{item.category}}</a>
      </span>
      <div class="right menu mw-search-box">
        <div class="item ms-search-box">
          <div class="ui icon input">
            <input id="search-field" type="text" placeholder="Meklēt..." :class="{ disabled: storeStatus.loading }" @keyup.enter="setSearchTerm($event.target.value)" :value="searchTerm">
            <i class="search link icon" :class="{ disabled: storeStatus.loading }" v-on:click.prevent="setSearchTerm($event.target.offsetParent.firstChild.value)"></i>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="right menu mw-search-box">
        <div class="item ms-search-box-mobile">
          <div class="ui icon input" style="margin-bottom: 20px;">
            <input id="search-field" type="text" placeholder="Meklēt..."
              @keyup.enter="setSearchTerm($event.target.value)" :value="searchTerm">
            <i class="search link icon" v-on:click="setSearchTerm($event.target.offsetParent.firstChild.value)"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['tempfix'], //will redirect user to goods page (later should update to show exact selected menu )
    data: function () {
      return {
        width: document.documentElement.clientWidth,
        sidebarOpen: true,
        selectedSubmenuArray: []
      }
    },
    
    computed: {
      category() {
        return this.$store.state.categoryStore.items
      },
      storeStatus() {
        return this.$store.state.goodStore.status;
      },
      searchTerm() {
        return this.$store.state.categoryStore.searchTerm
      },
      checkClientWidth() {
        return document.documentElement.clientWidth < 768
      },
      mobileViewCategory() {
        return [{ 'category': 'Visi produkti', 'category_a': [], 'id': '' }, ...this.$store.state.categoryStore.items]
      },
      homePage() {
        if (this.$route.path == "/" || this.$route.path == "/home" ) {
          return true
        } else {
          return false
        }
      }
    },
    
    watch: {
      width: function (newVal, oldVal) {
        if (newVal < 768) {
          this.checkClientWidth = true
        }

      },
      sidebarOpen: function (newVal, oldVal) {

      }
    },
    
    mounted() {
      document.getElementById("search-field").focus()
      var resizeTimer;
      var that = this;
      window.addEventListener("resize", function (e) {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          //console.log(e)
          if (this.width < 768) {
            that.checkClientWidth = true
          }
        }, 250);
      });

      //load categories and initiate menu
      this.$store.dispatch('loadCategory').then(function () {
        $('.categorymenu')
          .dropdown({
            action: 'hide'
          });
      });
    },
    
    created () {
      window.addEventListener('scroll', this.handleScroll);
      var header = document.querySelector('#fixed-header');
      if (header) header.style.top = '-100px';
    },
    unmounted () {
      window.removeEventListener('scroll', this.handleScroll);
      var header = document.querySelector('#fixed-header');
      if (header) header.style.top = '-100px';
    },

    methods: {
      handleScroll: function (event) {
          //console.log(window.scrollY);
          var header = document.querySelector('#fixed-header');
		  if (header) {
              if (window.scrollY > 350) {
                  header.style.top = '-5px';
              } else {
                  header.style.top = '-100px';
              }
		  }
      },
      
      setSearchTerm: function (term) {
        this.$store.commit('SET_CATEGORY_SEARCH_TERM', term);
        
        //reset category
        this.$store.commit('SET_SELECTED_CATEGORY', {
          category: '',
          categorya: '',
          categoryb: '',
          categoryLink:'',
          categoryaLink:'',
          categorybLink:''
        });
        
        if (this.homePage) {
          this.$router.push({
            name: 'goods'
          });
        } else {
          var page = 1;
          this.$emit('reload', 1);
          this.$store.dispatch('loadGood', [page, term, '', '', '']);
        }
      },

      filterCategory(category, categorya, categoryb, categoryLink, categoryaLink, categorybLink) {
        //reset search term
        this.$store.commit('SET_CATEGORY_SEARCH_TERM', '');

        this.$store.commit({
          type: 'SET_SELECTED_CATEGORY',
          category: category,
          categorya: categorya,
          categoryb: categoryb,
          categoryLink: categoryLink,
          categoryaLink: categoryaLink,
          categorybLink: categorybLink
        });

        if (categorybLink != '' && categoryaLink != '' && categoryLink != '') {
          this.$router.push({
            name: 'goods-categoryb-page',
            params: { categorylink: categoryLink, categoryalink: categoryaLink, categoryblink: categorybLink }
          });
        } else if (categoryaLink != '' && categoryLink != '') {
          this.$router.push({
            name: 'goods-categorya-page',
            params: { categorylink: categoryLink, categoryalink: categoryaLink }
          });
        } else if (categoryLink != '') {
          this.$router.push({
            name: 'goods-category-page',
            params: { categorylink: categoryLink }
          });
        } else /*if (this.tempfix)*/ {
          this.$router.push({
            name: 'goods'
          });
        }
        //else {
        //  var page = 1;
        //  this.$emit('reload', 1);
        //  this.$store.dispatch('loadGood', [page, this.searchTerm, category, categorya, categoryb]);
        //}
      },
    }
  }

</script>

<style>
  /* For IE */
  @media screen and (-ms-high-contrast: active),
  (-ms-high-contrast: none) {
    .ms-search-box input {
      width: 170px
    }
  }

  .secondary>span {
    padding-right: 0px !important;
    padding-left: 0px !important;
  }

  .ui.secondary.menu .item {
    margin-right: 0px !important;
    margin-left: 0px !important;
    padding-left: 3px !important;
    padding-right: 1.3rem !important;
  }

  .ms-search-box {
    width: 170px
  }

  .ms-search-box-mobile,
  .ms-search-box-mobile input {
    width: 87vw;
  }

  .mw-search-box {
    padding-left: 0px!important;
    margin-bottom: 15px!important;
  }
  
  .disabled {
    color: rgba(40, 40, 40, .3) !important;
    pointer-events: none;
  }
</style>


// WEBPACK FOOTER //
// CategoryMenu.vue?d7c3a3b0